/* eslint-disable import/no-unresolved */
import { Row, Col } from 'react-bootstrap';
import { Table } from 'appkit-react';

const FFIEC041AduitLog = ({
    data, columns,
}) => (
    <div className="true-comply-result__auditlog">
        {data && (
            <Row>
                <Col>
                    <div className="table-demo a-apply-theme-background-gray-level-1">
                        <Table
                            data={data}
                            columns={columns}
                            showPageSizeOptions={false}
                            defaultPageSize={10}
                            resizable
                            noDataText="No Audit Logs ..!!!"
                        />
                    </div>
                </Col>
            </Row>
        )}
    </div>
);

export default FFIEC041AduitLog;
